import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29023c41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-approvalStart" }
const _hoisted_2 = {
  key: 0,
  class: "event-code"
}
const _hoisted_3 = {
  key: 1,
  class: "event-code"
}
const _hoisted_4 = { class: "uf-button" }
const _hoisted_5 = { class: "uf-button--footer" }
const _hoisted_6 = { class: "police-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "police-title" }, [
  /*#__PURE__*/_createTextVNode(" 本平台仅提供技术支持，所有保险产品的销售、理赔等服务均由“"),
  /*#__PURE__*/_createElementVNode("span", null, "大童保险销售服务有限公司"),
  /*#__PURE__*/_createTextVNode("”提供 ")
], -1))
const _hoisted_8 = { class: "police-check" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "police-popup" }, [
  /*#__PURE__*/_createElementVNode("p", null, "尊敬的客户："),
  /*#__PURE__*/_createElementVNode("p", null, " 感谢您选择中国首家全国性保险专业销售服务机构——大童保险销售服务有限公司办理保险业务。为了您的合法权益得到有效保护，按照监管规定的要求，本公司履行客户告知义务，现将有关事项告知如下，请您认真阅读并签字（盖章）确认知悉以下内容： "),
  /*#__PURE__*/_createElementVNode("div", { class: "police-popup__title" }, "一、请您了解我公司基本情况"),
  /*#__PURE__*/_createElementVNode("p", null, "（一）名称：大童保险销售服务有限公司北京分公司"),
  /*#__PURE__*/_createElementVNode("p", null, " （二）业务范围：代理销售保险产品；代理收取保险费；代理相关保险业务的损失勘察和理赔；中国保监会批准的其他业务 "),
  /*#__PURE__*/_createElementVNode("p", null, "（三）联系方式：4006262828"),
  /*#__PURE__*/_createElementVNode("div", { class: "police-popup__title" }, " 二、请您了解购买的保险产品所属保险公司基本情况 "),
  /*#__PURE__*/_createElementVNode("p", null, " 您购买的是 中意财产 保险公司的产品，该保险公司业务范围是 团体险和财产险 ，相关信息您可以通过电话 4006002700 或者该公司位于 双子座大厦西塔9F 的当地营业场所进行查询。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "police-popup__title" }, " 三、请您客观评估自身的保险产品消费需求和缴费能力 "),
  /*#__PURE__*/_createElementVNode("p", null, " 根据保险监管部门规定，保险销售人员不得通过向投保人赠送权益证、价值证、股权激励凭证、待上市股票等不确定经济利益的方式推销保险产品，不得做出超出生效的书面保险合同责任范围的任何其他承诺。因此，请您客观评估自身的保险产品消费需求和缴费能力，根据自身实际的风险保障需求和经济实力选购合适的保险产品。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "police-popup__title" }, "四、请您确认销售人员的资格与权限"),
  /*#__PURE__*/_createElementVNode("p", null, " 我公司授权保险销售人员在客户办理投保、保全、理赔手续过程中提供指导和协助，为客户提供优质服务。对于您擅自委托销售人员代办超出我公司授权范围业务所产生的后果，我公司不承担任何经济和法律责任。如果您认为我公司保险销售人员或服务人员存在销售误导或其他损害您合法权益的行为，请您及时向我公司当地分公司投诉，联系方式请见本告知书公司基本情况。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "police-popup__title" }, " 五、请您详细了解保险产品、如实填写投保资料并亲笔签名 "),
  /*#__PURE__*/_createElementVNode("p", null, " 请您确认已仔细阅读保险条款，了解保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、犹豫期解除合同、退保损失、保险新型产品费用扣除及投资风险、健康保险产品等待期等重点内容。同时您可以要求我公司销售人员对上述内容进行详细讲解。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "police-popup__title" }, " 六、关联关系说明：我公司保险代理人及高级管理人员与您所投保的保险公司无关联关系。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "police-popup__title" }, " 七、如您发现我公司从业人员存在误导行为及其它损害您合法权益的行为，请注意保留书面证据或其他证据，可向我公司投诉（电话：4006262828）反映。 "),
  /*#__PURE__*/_createElementVNode("p", null, " 依据《保险法》，您作为投保人有如实告知义务。为了有效保障自身权益，您在投保单上填写的内容必须属实；投保提示书、投保单等各项投保文件、以及保单回执上要求投保人或被保险人填写、抄录并签名的地方，必须由投保人或被保险人本人亲笔填写、抄录并签名，不得互为代签或由他人代签。 "),
  /*#__PURE__*/_createElementVNode("p", null, "依法保护客户权益是我公司的神圣责任，更需要您的积极参与和认真配合。")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_sub_form_item_group = _resolveComponent("sub-form-item-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_uf_form = _resolveComponent("uf-form")!
  const _component_select_approve = _resolveComponent("select-approve")!
  const _component_rulesRegulations = _resolveComponent("rulesRegulations")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.tempInfo && Number(_ctx.tempInfo.operating_conditions_json?.is_have))
        ? (_openBlock(), _createBlock(_component_van_cell, {
            key: 0,
            class: "uf-approvalDetail__bigCell",
            title: "查看规章制度",
            border: false,
            "is-link": "",
            onClick: _ctx.lookRules
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_uf_form, {
        "show-error": "",
        "scroll-to-error": "",
        "show-error-message": false
      }, {
        default: _withCtx(() => [
          (_ctx.$route.query.eventId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "关联事务: " + _toDisplayString(_ctx.$route.query.eventCode), 1))
            : _createCommentVNode("", true),
          (_ctx.$route.query.alarmId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "关联报警: " + _toDisplayString(_ctx.$route.query.alarmCode), 1))
            : _createCommentVNode("", true),
          (_ctx.tempInfo)
            ? (_openBlock(), _createBlock(_component_sub_form_item_group, {
                list: _ctx.tempInfo.approval_json,
                id: _ctx.tempInfo.id,
                key: _ctx.tempInfo.id,
                ref: "subFormItemGroupRef"
              }, null, 8, ["list", "id"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_button, {
                class: "btn",
                block: "",
                color: "#3d6eeb",
                plain: "",
                square: "",
                type: "success",
                onClick: _ctx.saveTemp
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 保存草稿 ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_button, {
                class: "btn",
                block: "",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" 提交 ")
                      ], 64))
                    : (_openBlock(), _createBlock(_component_van_loading, { key: 1 }))
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_select_approve, {
      show: _ctx.selectApproveInfo.isShow,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectApproveInfo.isShow) = $event)),
      info: _ctx.selectApproveInfo.info,
      onSubmit: _ctx.selectApproveSubmit
    }, null, 8, ["show", "info", "onSubmit"]),
    (_ctx.tempInfo?.operating_conditions_json?.content)
      ? (_openBlock(), _createBlock(_component_rulesRegulations, {
          key: 0,
          show: _ctx.isShowrules.isRules,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowrules.isRules) = $event)),
          files: _ctx.tempInfo.operating_conditions_json.files_arr,
          content: _ctx.tempInfo.operating_conditions_json.content
        }, null, 8, ["show", "files", "content"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_dialog, {
      show: _ctx.policeInfo.dialogShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.policeInfo.dialogShow) = $event)),
      title: "该申请需购买保险",
      "show-cancel-button": "",
      "before-close": _ctx.policeInfo.beforeClose,
      onConfirm: _ctx.policeInfo.dialogConfirm,
      onCancel: _ctx.policeInfo.dialogCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_checkbox, {
              modelValue: _ctx.policeInfo.checked,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.policeInfo.checked) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("我已阅读"),
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.policeInfo.popupShow = true), ["stop"]))
                }, "《客户告知书》")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "before-close", "onConfirm", "onCancel"]),
    _createVNode(_component_van_popup, {
      show: _ctx.policeInfo.popupShow,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.policeInfo.popupShow) = $event)),
      round: "",
      position: "bottom",
      style: { height: '65%' }
    }, {
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}